import { SoftwareLink } from "../../api/api-generated";
import { numbersMatch } from "../../utils/comparisons";
import { SoftwareLinksFilter, SoftwareLinksForm } from "./linksTypes";

export const softwareLinksValidator = (item: SoftwareLinksForm) => {
  if (!item.name || !item.link || !item.software) return false;
  return true;
};

export const filterSoftwareLink = (
  item: SoftwareLink,
  filters: SoftwareLinksFilter
): boolean => {
  if (filters.software && !numbersMatch(filters.software.id, item.softwareId))
    return false;
  return true;
};

export const softwareLinksMiddleware = (
  name: string,
  value: string,
  state: any,
  autoboxValue?: object,
  autoboxLabel?: string
) => {
  if (autoboxLabel && autoboxLabel === "software")
    return { software: autoboxValue };
  return {};
};
